/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { createContext, useReducer } from "react";
import ModelContextStore from "cms/models/context/reducer";

/** @type {ModelContext} */
const defaultContext = {};
export const ModelContext = createContext(defaultContext);

const ModelProvider = (props) => {
    
    const { initState, children } = props;
    const [state, dispatch] = useReducer(ModelContextStore, initState);
    const ctx = { state, dispatch };
    
    return (
        <ModelContext.Provider value={ctx}>
            {children}
        </ModelContext.Provider>
    );
};

export default ModelProvider;


/**
 * @typedef {object} ModelContext
 * @property {ModelContextState} state
 * @property {import('react').DispatchWithoutAction} dispatch
 */

/**
 * @typedef {object} ModelContextState
 * @property {string} currentWebid
 * @property {object|null} schema
 * @property {boolean} childWebpagesPopoverOpen
 * @property {boolean} showAllChildren
 * @property {string} webpageGuid
 * @property {Array|null} childPages
 * @property {boolean} allCollapsed
 * @property {string} pageTitle
 * @property {boolean} isPageDirty
 * @property {Array} fieldlist
 * @property {object|null} fields
 * @property {string} mode
 * @property {boolean} preview
 * @property {boolean} labelDialogOpen
 */
